import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { ToggleHideIndex } from "./notification.actions";


export interface NotificationStateModel {
    hideIndex: boolean;
}

const defaults: NotificationStateModel = {
    hideIndex: false
}

@State<NotificationStateModel>({
    name: 'notification',
    defaults: defaults
})

@Injectable()
export class NotificationState {

    constructor() { }

    @Selector() static hideIndex(state: NotificationStateModel) { return state.hideIndex; }

    @Action(ToggleHideIndex) toggleHideIndex(ctx: StateContext<NotificationStateModel>, action: ToggleHideIndex) {
        const state = ctx.getState();
        ctx.setState({ ...state, hideIndex: action.payload });
    }

}